<template>
    <common-modal :heading="$t('modals.add_inactivity.title')" :width="'large'" :height="'medium'">
        <common-page-plain>
            <common-content-wrapper width="large">
                <add-inactivity-company-form
                    :availability="availability"
                    @out-if-avilability="outOfAvilability($event)"
                ></add-inactivity-company-form>
            </common-content-wrapper>
        </common-page-plain>
    </common-modal>
</template>

<script>
    import AddInactivityCompanyForm from 'components/forms/company/AddInactivityCompanyForm'

    export default {
        components: { AddInactivityCompanyForm },

        props: {
            availability: { type: Array, required: true },
            getId: { type: Number, default: 0 },
        },

        data() {
            return {
                upperLimit: null,
                lowerLimit: new Date(),
            }
        },

        methods: {
            outOfAvilability(event) {
                this.emitEvent({ name: 'out-if-avilability', payload: event })
            },
        },
    }
</script>
